(() => {
  const crossSellSliderEls = document.querySelectorAll('[data-cross-sell-slider]');

  const init = () => {
    if (!window.crossSellSliderInit) {
      window.crossSellSliderInit = true;

      Array.from(crossSellSliderEls).forEach((crossSellSliderEl) => {
        crossSellSliderEl.addEventListener('click', handleSlideClick);

        initSlider(crossSellSliderEl);
      });
    }
  }

  const handleSlideClick = (event) => {
    const el = event.target;
    const slide = el.closest('[data-cross-sell-slide]');

    if (el.hasAttribute('data-cross-sell-slide-variant')) {
      const variantId = el.dataset.crossSellSlideVariant;

      Array.from(slide.querySelectorAll('[data-cross-sell-slide-variant]')).forEach((slideVariantEl) => {
        slideVariantEl.classList.remove('active');
      });
      Array.from(slide.querySelectorAll('[data-cross-sell-slide-texts]')).forEach((slideTextsEl) => {
        slideTextsEl.classList.remove('active');
      });
      Array.from(slide.querySelectorAll('[data-cross-sell-slide-images-wrapper]')).forEach((slideImagesWrapperEl) => {
        slideImagesWrapperEl.classList.remove('active');
      });

      el.classList.add('active');
      const newActiveSlide = slide.querySelector(`[data-cross-sell-slide-texts="${variantId}"]`);
      if(newActiveSlide){
        newActiveSlide.classList.add('active');
      };
      slide.querySelector(`[data-cross-sell-slide-images-wrapper="${variantId}"]`).classList.add('active');
    }
  }

  const initSlider = (crossSellSliderEl) => {
    const slider = tns({
      container: crossSellSliderEl,
      fixedWidth: 242,
      gutter: 12,
      center: true,
      nav: false,
      mouseDrag: true,
      swipeAngle: false,
      loop: true,
      responsive: {
        1: {
          fixedWidth: 242
        },
        741: {
          fixedWidth: 448
        }
      },
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();